<template>
  <div class="form-calc">
    <h2 class="form-calc__title">
      Рассчитать <span class="form-calc__red-text">выгодный</span> кредит на этот автомобиль:
    </h2>
    <p class="form-calc__text">
      <b>Nissan Teana, 2011 год</b>
    </p>
    <p class="form-calc__text">
      Стоимость автомобиля, руб: 880000
    </p>

    <label class="form-calc__text form-calc__label">
      <span>Первоначальный взнос (укажите сумму в рублях):</span>
      <input
        v-model="initialFee"
        class="form-calc__input form-calc__input_wide"
        type="number"
        name="initial_fee"
      >
    </label>
    <label class="form-calc__text form-calc__label">
      <span>Желаемый срок кредита (лет):</span>
      <input
        v-model="term"
        class="form-calc__input"
        type="number"
        name="credit_term"
      >
    </label>

    <p class="form-calc__text">
      <b>Результаты расчета:</b>
    </p>

    <p
      v-if="!sum"
      class="form-calc__text"
    >
      Чтобы увидеть сумму платежа в месяц заполните первоначальный взнос и срок кредита
    </p>

    <div
      v-else
      class="form-calc__results"
    >
      <span class="form-calc__text">От: {{ sum.from }}</span>
      <span class="form-calc__text">До: {{ sum.to }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormCalc',
  data() {
    return {
      initialFee: null,
      term: null,
    }
  },
  computed: {
    sum() {
      if (this.initialFee > 0 && this.term > 0) {
        return {
          from: 14950,
          to: 19500,
        }
      } else {
        return null
      }
    },
  },
}
</script>

<style lang="scss">
  .form-calc {
    &__title {
      margin-top: 0;
      color: #2c2c2c;
      font-weight: 400;
      font-size: 20px;
      text-align: left;
    }

    &__text {
      display: block;
      color: #2c2c2c;
      font-size: 16px;

      b {
        font-weight: 500;
      }
    }

    &__red-text {
      color: #ff4638;
    }

    &__results {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    &__label {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    &__input {
      flex-grow: 1;
      max-width: 30%;
      height: 30px;
      padding: 5px 8px;
      font-weight: 300;
      font-size: 13px;
      text-indent: 3px;
      border: 1px solid #c4c4c4;
      border-radius: 3px;
      cursor: default;

      &_wide {
        max-width: 40%;
      }
    }
  }
</style>
